import { render } from "./KeyStorageView.vue?vue&type=template&id=745cb31c&ts=true"
import script from "./KeyStorageView.vue?vue&type=script&lang=ts"
export * from "./KeyStorageView.vue?vue&type=script&lang=ts"

import "./KeyStorageView.vue?vue&type=style&index=0&id=745cb31c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__